export default __webpack_public_path__ + "static/vc-4416a5800cb99918b30fef3716a78518.svg";